import { Site } from '@envato/foundation-types'

interface INoIndexParams {
  name: string
  value: string
}

interface INoIndexAllowList {
  site: Site
  routes: string[]
  params: INoIndexParams[]
}

const noIndexAllowList = ({ site, routes, params }: INoIndexAllowList) => {
  const allowedTags = [
    {
      name: 'advertising',
      sites: [
        Site.audiojungle,
        Site.codecanyon,
        Site.themeforest,
        Site.videohive
      ]
    },
    {
      name: 'arabic',
      sites: [
        Site.audiojungle,
        Site.threedocean,
        Site.themeforest,
        Site.videohive
      ]
    },
    {
      name: 'black friday',
      sites: [
        Site.audiojungle,
        Site.codecanyon,
        Site.themeforest,
        Site.videohive
      ]
    },
    {
      name: 'erotic',
      sites: [
        Site.audiojungle,
        Site.threedocean,
        Site.photodune,
        Site.videohive
      ]
    },
    {
      name: 'happy new year',
      sites: [Site.audiojungle, Site.themeforest, Site.videohive]
    },
    {
      name: 'quiz',
      sites: [
        Site.audiojungle,
        Site.codecanyon,
        Site.themeforest,
        Site.videohive
      ]
    },
    {
      name: 'real estate',
      sites: [
        Site.audiojungle,
        Site.codecanyon,
        Site.themeforest,
        Site.videohive
      ]
    },
    {
      name: 'sell',
      sites: [
        Site.threedocean,
        Site.codecanyon,
        Site.themeforest,
        Site.videohive
      ]
    },
    {
      name: 'social media',
      sites: [
        Site.threedocean,
        Site.photodune,
        Site.themeforest,
        Site.videohive
      ]
    },
    {
      name: 'subscription',
      sites: [
        Site.audiojungle,
        Site.photodune,
        Site.themeforest,
        Site.videohive
      ]
    },
    {
      name: 'youtube',
      sites: [
        Site.audiojungle,
        Site.codecanyon,
        Site.themeforest,
        Site.videohive
      ]
    }
  ]

  // Filter tags by site
  const allowedTagsBySite = allowedTags.filter(tag => tag.sites.includes(site))

  // Iterate over allow tags list and build out params
  const tagsParams = allowedTagsBySite.map(tag => {
    return { name: 'tags', value: tag.name }
  })

  return {
    routes: routes.concat([]),
    params: tagsParams.concat(params)
  }
}

export default noIndexAllowList
